import { ConfirmationData } from "../../../../common/summary-common/confirmationData";

export const overWriteRelationInformation: Map<string, ConfirmationData> = new Map([
   
    ["2ded8c95-3f3d-456d-9b41-d008db677634", { hidden: true }],
]); 